/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { AppListItem } from 'types/app-list';
import { MeasuresCount, MeasuresData } from 'types/measures-api-data';

//  Aggregates and filters error and performance badge counts from visible apps only
export const calculateBadgeData = (
  measures: MeasuresData,
  data: AppListItem[],
  showExamples: boolean
): MeasuresCount => {
  return Object.entries(measures ?? {})
    .filter(([appName]) => {
      const app = data.find((appData) => appData.name === appName);
      if (!app) return false;
      if (!showExamples && app.is_playground) return false;

      return true;
    })
    .reduce(
      (acc, [, measure]) => {
        if (measure.errors > 0) acc.errors += 1;
        if (measure.not_meet_sla > 0) acc.not_meet_sla += 1;
        if (measure.not_meet_budget_sla > 0) acc.not_meet_budget_sla += 1;
        if (measure.test_failures > 0) acc.test_failures += 1;
        return acc;
      },
      { errors: 0, not_meet_sla: 0, not_meet_budget_sla: 0, test_failures: 0 }
    );
};
